import React from 'react';
import { IconType } from 'react-icons';

export const DIMENSION_STYLES = {
  container: "space-y-6",
  header: "bg-gradient-to-r from-white to-blue-50 p-4 rounded-lg shadow-md border border-blue-100",
  title: "text-xl font-bold text-gray-800 flex items-center bg-blue-50 px-3 py-1 rounded-md border-l-4 border-blue-500",
  courseSelector: "w-full px-3 py-2 text-sm text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none cursor-pointer hover:border-blue-400 transition-colors"
};

interface UnifiedHeaderProps {
  dimensionName: string;
  icon: IconType;
  skillsCount: number;
  selectedCourse: string;
  courses: string[];
  onCourseChange: (course: string) => void;
}

export const UnifiedHeader: React.FC<UnifiedHeaderProps> = ({
  dimensionName,
  icon: Icon,
  skillsCount,
  selectedCourse,
  courses,
  onCourseChange
}) => {
  return (
    <div className="bg-gradient-to-r from-white to-blue-50 p-4 rounded-lg shadow-md border border-blue-100">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
        <div className="w-full md:w-auto">
          <h2 className="text-xl font-bold text-gray-800 flex items-center bg-blue-50 px-3 py-1 rounded-md border-l-4 border-blue-500">
            <Icon className="mr-2 text-blue-600" />
            Registro de {dimensionName}
          </h2>
          <p className="text-sm text-gray-600 mt-1">
            {skillsCount} habilidades cargadas desde CSV
          </p>
        </div>
        
        <div className="flex items-center gap-3 flex-wrap">
          <label className="text-sm font-medium text-gray-600 whitespace-nowrap">Curso:</label>
          <div className="relative min-w-[180px]">
            <select
              value={selectedCourse}
              onChange={(e) => onCourseChange(e.target.value)}
              className="w-full px-3 py-2 text-sm text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none cursor-pointer hover:border-blue-400 transition-colors"
            >
              <option value="">📚 Todos los cursos</option>
              {courses.map((course, index) => (
                <option key={index} value={course}>
                  📖 {course}
                </option>
              ))}
            </select>
            <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
              <svg className="w-4 h-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const UnifiedLegend: React.FC = () => {
  return (
    <div className="mt-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
      <h4 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
        <span className="mr-2">🎯</span>
        Leyenda de colores para niveles de desarrollo:
      </h4>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        <div className="flex items-center">
          <div className="w-6 h-6 bg-blue-500 rounded mr-2 shadow-sm border"></div>
          <span className="text-sm text-gray-600">
            <span className="font-medium">Nivel seleccionado</span> - Nivel evaluado para el estudiante
          </span>
        </div>
        <div className="flex items-center">
          <div className="w-6 h-6 bg-yellow-50 border-2 border-yellow-400 rounded mr-2"></div>
          <span className="text-sm text-gray-600">
            <span className="font-medium">Nivel esperado</span> - Nivel correspondiente a la edad
          </span>
        </div>
        <div className="flex items-center">
          <div className="w-6 h-6 bg-gray-50 border-2 border-gray-400 rounded mr-2"></div>
          <span className="text-sm text-gray-600">
            <span className="font-medium">Nivel año anterior</span> - Nivel del año previo
          </span>
        </div>
        <div className="flex items-center">
          <div className="w-6 h-6 bg-blue-50 border border-blue-300 rounded mr-2"></div>
          <span className="text-sm text-gray-600">
            <span className="font-medium">Previamente seleccionado</span> - Nivel anterior guardado
          </span>
        </div>
        <div className="flex items-center">
          <div className="w-6 h-6 bg-white border border-gray-200 rounded mr-2 hover:bg-blue-50"></div>
          <span className="text-sm text-gray-600">
            <span className="font-medium">Sin seleccionar</span> - Nivel disponible para evaluar
          </span>
        </div>
        <div className="flex items-center">
          <div className="w-6 h-6 bg-gray-50 rounded mr-2 border flex items-center justify-center">
            <span className="text-xs text-gray-400 italic">N/A</span>
          </div>
          <span className="text-sm text-gray-600">
            <span className="font-medium">No aplica</span> - No corresponde para esta edad
          </span>
        </div>
      </div>
      <div className="mt-3 pt-3 border-t border-gray-300">
        <p className="text-xs text-gray-500 italic">
          💡 <strong>Tip:</strong> Los colores ayudan a identificar rápidamente el progreso de cada estudiante según su edad y desarrollo esperado.
        </p>
      </div>
    </div>
  );
};